import {LitElement, html} from "../libs/lit.dist.js";
import styles from './pk-stepper-step.css.js';

export class PkStepperStep extends LitElement {

    static styles = styles;

    static properties = {
        step: {type: Number, reflect: true},
        label: {type: String},
        done: {type: Boolean, reflect: true},
        current: {type: Boolean, reflect: true},
        horizontal: {type: Boolean, reflect: true},
    }

    update(t) {
        super.update(t);
        if (t.has('current') && t.get('current') && !this.current && !this.done) {
            this.setAttribute('animate-out', '');
        }
    }

    #onAnimationEnd(e) {
        if (e.animationName === 'progress-out' || e.animationName === 'progress-out-horizontal') {
            this.removeAttribute('animate-out');
        }
    }

    render() {
        return html`
            <div
                class="progress"
                @animationend="${this.#onAnimationEnd}"
                @animationcancel="${this.#onAnimationEnd}"
            >
                <div class="progress-bar"></div>
                <slot name="icon">
                    <div class="icon">
                        <pk-icon icon="check"></pk-icon>
                    </div>
                </slot>
            </div>
            <div class="content">
                <slot name="label">
                    <span class="label">Krok ${this.step}</span>
                </slot>
                <div class="content-label">
                    <slot></slot>
                </div>
            </div>
        `;
    }
}

if (!customElements.get('pk-stepper-step')) {
    customElements.define('pk-stepper-step', PkStepperStep);
}
